const STORAGE_KEY = "qk_chatbot_visitor_id";

function createId(): string {
  if ("randomUUID" in crypto) {
    return crypto.randomUUID();
  }

  return `visitor_${Date.now()}_${Math.random().toString(36).slice(2)}`;
}

export function getVisitorId(): string {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return stored;
    }

    const id = createId();
    window.localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    return createId();
  }
}
